import AsyncStorage from "@react-native-async-storage/async-storage";

const ACCESS_TOKEN_KEY = "lunaSchoolAccessToken";
const REFRESH_TOKEN_KEY = "lunaSchoolRefreshToken";

export const authStorage = {
  getAccessToken: async (): Promise<string | null> => {
    return AsyncStorage.getItem(ACCESS_TOKEN_KEY);
  },
  setAccessToken: async (token: string | null): Promise<void> => {
    if (token === null) {
      await AsyncStorage.removeItem(ACCESS_TOKEN_KEY);
    } else {
      await AsyncStorage.setItem(ACCESS_TOKEN_KEY, token);
    }
  },
  getRefreshToken: async (): Promise<string | null> => {
    return AsyncStorage.getItem(REFRESH_TOKEN_KEY);
  },
  setRefreshToken: async (token: string | null): Promise<void> => {
    if (token === null) {
      await AsyncStorage.removeItem(REFRESH_TOKEN_KEY);
    } else {
      await AsyncStorage.setItem(REFRESH_TOKEN_KEY, token);
    }
  },
  clear: async (): Promise<void> => {
    await AsyncStorage.multiRemove([ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY]);
  },
};
